var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccordionChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.346,
    height: 8.588
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 429",
    d: "M.707.707l6.466 6.467L13.639.707",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })));
}

export default __webpack_public_path__ + "dcb735bba7060ffcb273e90e1275542e.svg";
export { SvgAccordionChevron as ReactComponent };